// Shared responsive breakpoints for the app.
// Screens at or below MOBILE_MAX_WIDTH use the mobile-first reservation flow.
export const MOBILE_MAX_WIDTH = 768;
